import { Injectable, OnDestroy } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';

import { ChatDto, EntityMetaDto, NotificationMessageDto, UserDto } from 'src/app/api';

import { CerAppChatService } from '../cer-app-chat/cer-app-chat.service';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

export class NotificationMessageLinkDto extends NotificationMessageDto {
  public queryParams?: Params;
}

@Injectable({
  providedIn: 'root'
})
export class CerAppNotificationService implements OnDestroy {

  private subscriptionManager$: Subscription = new Subscription();

  public userNotifications$ = new BehaviorSubject<NotificationMessageLinkDto[]>(null);
  public entities: EntityMetaDto[] = null;

  constructor(private chatService: CerAppChatService, private session: CerSessionService) {

    this.subscriptionManager$.add(
      this.session.user.notifications$.subscribe(msgs => this.userNotificationsSet(msgs))
    );

    this.subscriptionManager$.add(
      this.session.user.entities$.subscribe(entities => this.entities = entities)
    );

    this.subscriptionManager$.add(
      this.chatService.chats$.subscribe(chats => this.userNotificationsAddFromChats(this.userNotifications$.value, chats))
    );
  }

  public ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }


  public userNotificationsSet(messages: NotificationMessageLinkDto[], adjustDateType: boolean = true) {
    messages?.forEach(msg => this.prepareNotification(msg, adjustDateType));
    this.userNotifications$.next(messages);
  }

  public userNotificationsAddFromChats(messages: NotificationMessageLinkDto[], chats: ChatDto[]) {
    chats.forEach(chat => this.userNotificationsAddFromChat(messages, chat));
  }

  private userNotificationsAddFromChat(messages: NotificationMessageLinkDto[], chat: ChatDto) {
    var userId: number = this.session.user.id();
    if (userId && chat.id && chat.chatUsers && messages) {
      var chatUser = chat.chatUsers.find(cu => cu.userId == userId);
      if (chatUser) {
        var message = messages.find(m => m.chatId == chat.id);
        if (message) {
          var chatUser = chat.chatUsers.find(cu => cu.userId == userId);
          message.isRead = chatUser.isRead;
          message.isNotified = chatUser.isRead; // TODO: Isnotified!!!
        }
        else {
          message = new NotificationMessageLinkDto();
          message.txt = chat.txt;
          message.chatId = chat.id;
          message.userId = chatUser.userId;
          message.fromUserId = chatUser.createdBy;
          message.refTableId = chat.refTableId;
          message.refRowId = chat.refRowId;
          message.isRead = chatUser.isRead;
          message.isNotified = chatUser.isRead;
          message.created = new Date(chat.created);
          message.createdBy = chat.createdBy;
          message.modified = new Date(chat.modified);
          message.modifiedBy = chat.modifiedBy;
          var user: UserDto = this.getUserById(message.userId);
          if (user) {
            message.userName = user.name;
            message.userShortName = user.shortName;
          }
          message.fromUserId = chat.createdBy;
          var user: UserDto = this.getUserById(message.fromUserId);
          if (user) {
            message.fromUserName = user.name;
            message.fromShortName = user.shortName;
          }
          this.prepareNotification(message, false);
          messages.unshift(message);
        }
      }
      this.userNotifications$.next(messages);
    }
  }

  private getUserById(userId: number): UserDto {
    return this.session.users.userById(userId);
  }

  public prepareNotifications(messages: NotificationMessageLinkDto[], adjustDateType: boolean) {
  }

  private prepareNotification(msg: NotificationMessageLinkDto, adjustDateType: boolean = true) {
    if (adjustDateType) {
      msg.created = new Date(msg.created);
      msg.modified = new Date(msg.modified);
    }
    if (msg.refTableId != null && msg.refRowId != null) {
      var entityName = this.entityNameByTableId(msg.refTableId);
      this.prepareNotificationUrl(msg, entityName);
    }
  }

  private prepareNotificationUrl(msg: NotificationMessageLinkDto, entityName: string) {
    if (entityName != null && entityName.length > 0) {
      switch (entityName) {
        case 'VoucherView':
          msg.url = encodeURI('/voucher/chat/' + String(msg.refRowId));
          break;
        case 'DataNotification':
          msg.url = encodeURI("/notification");
          msg.queryParams = { id: msg.refRowId };
          break;
      }
    }
  }

  private entityNameByTableId(tableId: number): string {
    if (tableId == 1) {
      return "VoucherView";
    }
    if (this.entities != null && this.entities.length > 0) {
      return this.entities.find(e => e.id == tableId)?.name;
    }
    return null;
  }

  /*
  private convertDateToUTC(date: Date): Date {
    if (date != null) {
      date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }
    return date;
  }*/
}
